<template>
  <button
    ref="focusbtn"
    class="position-relative"
    :class="isDropdownItem ? 'dropdown-item' : cssClasses"
    @click="onClick"
  >
    <div
      v-if="disabled"
      class="progress position-absolute abs-progress"
    >
      <div
        class="progress-bar progress-bar-striped progress-bar-animated"
        :class="'bg-' + getVariant"
        style="width: 100%"
      />
    </div>

    <slot />
  </button>
</template>

<script>
import { debounce } from 'lodash';

export default {
  props: {
    promise: {
      type: Function,
      required: true
    },
    params: {
      type: Object,
      required: false,
      default: () => {}
    },
    callback: {
      type: Function,
      required: false,
      default: null
    },
    variant: {
      type: String,
      required: false,
      default: 'secondary'
    },
    size: {
      type: String,
      required: false,
      default: 'md'
    },
    block: {
      type: Boolean,
      required: false,
      default: false
    },
    isDropdownItem: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['then', 'catch'],
  data() {
    return {
      disabled: false
    };
  },
  computed: {
    getVariant() {
      return ['outline-light', 'link'].includes(this.variant)
        ? 'secondary'
        : this.variant;
    },
    cssClasses() {
      let classes = `btn btn-${this.variant} btn-${this.size}`;
      if (this.disabled) {
        classes += ' disabled ';
      }
      if (this.block) {
        classes += ' d-md-block w-100';
      }

      return classes;
    }
  },
  methods: {
    fetch: debounce(function () {
      Promise.resolve(this.promise(this.params))
        .then((res) => {
          this.disabled = false;
          this.$refs.focusbtn ? this.$refs.focusbtn.focus() : null;
          if (this.callback) {
            this.callback();
          }
          this.$emit('then', res);
        })
        .catch((err) => {
          this.disabled = false;
          this.$emit('catch', err);
        });
    }, 250),

    onClick() {
      this.disabled = true;
      this.fetch();
    }
  }
};
</script>

<style lang="scss">
.abs-progress {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.5;
}
</style>
